var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.813,
    height: 27.871,
    viewBox: "0 0 27.813 27.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.085,9.638H35.5v3.187H34.345a.367.367,0,0,0-.29.579l1.97,2.2a.326.326,0,0,0,.521,0l1.97-2.2c.232-.232.058-.579-.29-.579h-1.1v-3.3A1.62,1.62,0,0,0,35.5,7.9H31.969a.891.891,0,0,0-.869.869A1.041,1.041,0,0,0,32.085,9.638Z",
    transform: "translate(-13.659 -3.902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.455,33.774H8.036V30.587H9.2a.367.367,0,0,0,.29-.579l-1.97-2.2a.326.326,0,0,0-.521,0l-1.97,2.2c-.232.232-.058.579.29.579h1.1v3.3a1.62,1.62,0,0,0,1.622,1.622h3.535a.891.891,0,0,0,.869-.869A1.1,1.1,0,0,0,11.455,33.774Z",
    transform: "translate(-2.648 -12.219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.935,2.275A1.286,1.286,0,0,0,15.66,1H2.275A1.286,1.286,0,0,0,1,2.275V9.228H16.935Z",
    transform: "translate(-1 -1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.935,17.343V16.3H1v1.043a1.286,1.286,0,0,0,1.275,1.275H15.66A1.286,1.286,0,0,0,16.935,17.343Z",
    transform: "translate(-1 -7.435)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.886,22.575a.643.643,0,0,0-.637-.637h-.985V21.3H9.222v.637H8.237a.637.637,0,1,0,0,1.275h7.011A.685.685,0,0,0,15.886,22.575Z",
    transform: "translate(-3.776 -9.537)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.16,25.5H22.775A1.286,1.286,0,0,0,21.5,26.775v6.953H37.435V26.775A1.286,1.286,0,0,0,36.16,25.5Z",
    transform: "translate(-9.622 -11.304)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.5,41.743a1.286,1.286,0,0,0,1.275,1.275H36.16a1.286,1.286,0,0,0,1.275-1.275V40.7H21.5Z",
    transform: "translate(-9.622 -17.696)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.749,46.437h-.985V45.8H29.722v.637h-.985a.637.637,0,1,0,0,1.275h7.011a.643.643,0,0,0,.637-.637A.608.608,0,0,0,35.749,46.437Z",
    transform: "translate(-12.397 -19.841)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteAccess);
export default __webpack_public_path__ + "static/media/remote_access.f5bdd6a2.svg";
export { ForwardRef as ReactComponent };